<template>
  <div class="homePage" :style="'min-height:' + height + 'px'">
    <Header :key="key"></Header>
    <router-view :key="key"></router-view>
    <!-- <Footer></Footer> -->
    <component :platInfo="platInfo" :is="currentFooter" v-if="currentFooter" />
  </div>
</template>
<script>
import { ref, getCurrentInstance, onMounted,watch, computed, defineAsyncComponent  } from "vue";
import Header from "../view/shopDecoration/components/page/header.vue";
// import Footer from "@/components/dealFooter/foot.vue";
import { useStore } from "vuex";
export default {
  name: "homePage",
  components: { Header },
  props:{
      platInfo: {
          type: Object,
          default: {}
      }
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const store =useStore();
    const key =ref(0);
    const height = ref(document.documentElement.clientHeight);
    // 监听浏览器尺寸变化
     watch(
      () => store.state.locale,
      (newVal) => {
        key.value+=1
        console.log('someData changed:', newVal)
      },
      { deep: true } // 如果需要深度监听
    )
    onMounted(() => {
      if(proxy.getCookie("userInfoB2B")){
        proxy.$store.commit('setUserInfoB2B',JSON.parse(proxy.getCookie("userInfoB2B")).user)
      }
      window.addEventListener("resize", () => {
        // 监听页面尺寸变化
        // console.log(document.documentElement.clientHeight);
        height.value = document.documentElement.clientHeight;
      });
    });
    const projectType = computed(() => {
      // 可以从这些地方获取项目类型（按优先级）：
      // 1. 路由参数
      // 2. Vuex store
      // 3. 环境变量
      return process.argv.project
    });
    const footerLoaded = ref(false);
     // 最可靠的动态加载方案
    const loadFooterComponent = (projectType) => {
      // 预定义的组件映射表
      const FOOTER_MAP = {
        qqshangtong: () => import('@/components/dealFooter/qqshangtong/footer.vue'),
        default: () => import('@/components/dealFooter/common/foot.vue')
      };

      // 标准化项目类型（统一小写+去除前后空格）
      const normalizedType = String(projectType).toLowerCase().trim();
      
      // 添加Webpack魔法注释（构建优化）
      const dynamicImport = FOOTER_MAP[normalizedType] || FOOTER_MAP.default;
      const loader = () => import(/* webpackChunkName: "footer-[request]" */ `@/components/dealFooter/${normalizedType}/foot.vue`)
        .catch(() => FOOTER_MAP.default());

      // 返回带错误边界的异步组件
      return defineAsyncComponent({
        loader: dynamicImport,
        loadingComponent: {
          template: '<div class="footer-loading"></div>'
        },
        errorComponent: {
          template: '<div class="footer-error">页脚加载失败</div>'
        },
        delay: 200,
        timeout: 3000
      });
    };

    // 使用示例
    const currentFooter = computed(() => {
      let project = process.argv.project || 'default';
      if(process.argv.project=='developement'||process.argv.project=='test'||process.argv.project=='inner-trade'){
        project='qqshangtong'
      }
 
      // const project = 'qqshangtong'
      return loadFooterComponent(project);
    });
    return {
      height,
      key,
      currentFooter,
      footerLoaded
    };
  },
};
</script>
<style scoped lang="less">
.homePage {
  // overflow: hidden;
  .container {
    display: flex;
    border-top: 1px solid #f7f8fa;
  }
  .rightContainer {
    flex-grow: 1;
    width: calc(100% - 240px);
    background-color: #f7f8fa;
  }
  :deep(.auth-dialog){
    .auth-dialog-main{
      width: 100%;
      display: flex;
      justify-content: center;
      .auth-dialog-main-panel{
        width: 320px;
      }
    }
    .auth-other-opt{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .down-btn{
        font-size: 12px;
        a{
          color: #3e7fff;
        }
      }
    }
    .auth-dialog-footer{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .tips{
        width: 70%;
        font-size: 12px;
        color: #c7c7c7;
        text-align: left;
        font-family: PingFangSC-Regular;
      }
    }
  }
}
</style>
